// Tutoriels fonctionnalités & gestion

export const TUTORIALS_FEATURES = {
  // ==================== SIMULATEUR ====================
  simulateur: {
    id: 'simulateur',
    name: 'Utilisation du Simulateur',
    steps: [
      {
        targetId: 'simulateur-intro',
        title: '🧮 Simulateur Garantie Solidaire BATICO',
        content: 'Ce simulateur vous permet de calculer votre contribution et découvrir les dispositifs adaptés à votre entreprise.',
        position: 'bottom'
      },
      {
        targetId: 'entreprise-info',
        title: '🏢 Informations Entreprise',
        content: 'Renseignez les informations de votre entreprise : SIRET, chiffre d\'affaires, effectif.',
        position: 'bottom'
      },
      {
        targetId: 'activites-selector',
        title: '📋 Sélection des Activités',
        content: 'Sélectionnez vos activités parmi les catégories : Gros Œuvre, Second Œuvre, Travaux Publics, PIB.',
        position: 'right'
      },
      {
        targetId: 'calcul-button',
        title: '🔢 Calculer ma Contribution',
        content: 'Cliquez sur ce bouton pour obtenir le calcul de votre contribution solidaire.',
        position: 'top'
      },
      {
        targetId: 'resultat-section',
        title: '📊 Résultat',
        content: 'Consultez le détail de votre contribution : montant de base, taxes, total Global.',
        position: 'top'
      }
    ]
  },

  // ==================== GESTION VIDÉOS ====================
  videos_management: {
    id: 'videos_management',
    name: 'Gestion des Vidéos',
    steps: [
      {
        targetId: 'videos-intro',
        title: '🎬 Gestion des Vidéos',
        content: 'Cette section vous permet d\'importer, organiser et partager vos fichiers vidéos.',
        position: 'bottom'
      },
      {
        targetId: 'import-video',
        title: '📤 Importer une Vidéo',
        content: 'Cliquez ici pour importer une vidéo. Formats acceptés: MP4, WebM, AVI, MOV, MKV. Taille max: 500 MB.',
        position: 'left'
      },
      {
        targetId: 'search-videos',
        title: '🔍 Rechercher',
        content: 'Utilisez la barre de recherche pour trouver rapidement une vidéo par son nom.',
        position: 'bottom'
      },
      {
        targetId: 'video-card',
        title: '🎥 Carte Vidéo',
        content: 'Chaque vidéo affiche un aperçu, sa taille et sa date d\'upload. Cliquez pour la lire.',
        position: 'bottom'
      },
      {
        targetId: 'video-actions',
        title: '⚡ Actions',
        content: 'Pour chaque vidéo : Voir (lecture), Télécharger (export), Supprimer.',
        position: 'left'
      }
    ]
  },

  // ==================== ABONNEMENTS ====================
  subscription_management: {
    id: 'subscription_management',
    name: 'Gestion des abonnements',
    steps: [
      {
        targetId: 'plans-comparison',
        title: '🎯 Choisir sa formule',
        content: 'Comparez les différentes formules disponibles. Chaque tier offre plus de crédits et d\'avantages.',
        position: 'bottom'
      },
      {
        targetId: 'credits-info',
        title: '🎁 Crédits Offerts',
        content: 'Les crédits inclus se renouvellent chaque mois et peuvent être utilisés pour accélérer vos démarches.',
        position: 'bottom'
      },
      {
        targetId: 'billing-cycle',
        title: '📅 Cycle de Facturation',
        content: 'Choisissez entre paiement mensuel ou annuel. L\'abonnement annuel vous fait économiser 2 mois !',
        position: 'top'
      },
      {
        targetId: 'comparison-table',
        title: '📊 Tableau Comparatif',
        content: 'Consultez le détail de chaque fonctionnalité pour faire le meilleur choix selon vos besoins.',
        position: 'top'
      }
    ]
  },

  // ==================== WALLET ====================
  wallet_management: {
    id: 'wallet_management',
    name: 'Gestion du portefeuille',
    steps: [
      {
        targetId: 'wallet-balance',
        title: '💰 Votre Solde',
        content: 'Voici votre solde actuel de crédits, utilisables pour les services premium.',
        position: 'bottom'
      },
      {
        targetId: 'credit-usage',
        title: '💡 Utilisation des Crédits',
        content: 'Les crédits permettent d\'accéder aux attestations urgentes, expertises prioritaires et documents premium.',
        position: 'bottom'
      },
      {
        targetId: 'credit-packages',
        title: '📦 Packages de Crédits',
        content: 'Achetez des crédits par packages. Plus vous en achetez, plus l\'économie est importante (jusqu\'à 40% !)',
        position: 'top'
      },
      {
        targetId: 'transaction-history',
        title: '📜 Historique',
        content: 'Suivez toutes vos transactions et l\'utilisation de vos crédits en temps réel.',
        position: 'top'
      }
    ]
  },

  // ==================== BIBLIOTHÈQUE ====================
  bibliotheque: {
    id: 'bibliotheque',
    name: 'Utilisation de la bibliothèque',
    steps: [
      {
        targetId: 'categories-filter',
        title: '🗂️ Catégories',
        content: 'Filtrez les documents par catégorie pour trouver rapidement ce dont vous avez besoin.',
        position: 'right'
      },
      {
        targetId: 'document-card',
        title: '📄 Fiche Document',
        content: 'Chaque document affiche un aperçu, sa catégorie et les actions disponibles (voir, télécharger).',
        position: 'bottom'
      },
      {
        targetId: 'view-document',
        title: '👁️ Voir le Modèle',
        content: 'Cliquez ici pour prévisualiser le contenu complet du document avant de le télécharger.',
        position: 'left'
      },
      {
        targetId: 'download-document',
        title: '⬇️ Télécharger',
        content: 'Téléchargez le document au format souhaité pour l\'éditer et l\'adapter à vos besoins.',
        position: 'left'
      }
    ]
  },

  // ==================== MESSAGERIE ====================
  messaging: {
    id: 'messaging',
    name: 'Utilisation de la messagerie',
    steps: [
      {
        targetId: 'conversations-list',
        title: '💬 Vos Conversations',
        content: 'Toutes vos conversations actives apparaissent ici. Les messages non lus sont mis en évidence.',
        position: 'right'
      },
      {
        targetId: 'search-box',
        title: '🔍 Rechercher',
        content: 'Recherchez rapidement une conversation par nom ou contenu de message.',
        position: 'bottom'
      },
      {
        targetId: 'message-area',
        title: '📝 Zone de Messages',
        content: 'Vos messages s\'affichent ici en temps réel. Le système est entièrement temps réel.',
        position: 'left'
      },
      {
        targetId: 'compose-message',
        title: '✍️ Nouveau Message',
        content: 'Cliquez ici pour démarrer une nouvelle conversation avec un expert, conseiller ou support.',
        position: 'top'
      },
      {
        targetId: 'attach-file',
        title: '📎 Pièces Jointes',
        content: 'Joignez des documents, images ou vidéos à vos messages.',
        position: 'top'
      }
    ]
  },

  // ==================== DÉCLARATION SINISTRE ====================
  declare_dommage: {
    id: 'declare_dommage',
    name: 'Déclarer un dommage',
    steps: [
      {
        targetId: 'form-intro',
        title: '📝 Formulaire de Déclaration',
        content: 'Remplissez ce formulaire pour déclarer un nouveau dommage. Un expert sera assigné automatiquement.',
        position: 'bottom'
      },
      {
        targetId: 'type-dommage',
        title: '🔧 Type de Dommage',
        content: 'Sélectionnez le type de dommage parmi la liste. Cela permettra d\'assigner le bon expert.',
        position: 'bottom'
      },
      {
        targetId: 'description-field',
        title: '📄 Description Détaillée',
        content: 'Décrivez le dommage en détail : circonstances, dégâts constatés, urgence, etc.',
        position: 'top'
      },
      {
        targetId: 'photos-upload',
        title: '📸 Photos',
        content: 'Ajoutez des photos du dommage. Plus vous en fournissez, plus l\'expertise sera rapide et précise.',
        position: 'top'
      },
      {
        targetId: 'videos-upload',
        title: '🎬 Vidéos',
        content: 'Vous pouvez également joindre des vidéos pour documenter le dommage.',
        position: 'top'
      },
      {
        targetId: 'priority-selector',
        title: '⚡ Priorité',
        content: 'Utilisez des crédits pour obtenir une expertise prioritaire (traitement accéléré 24-48h).',
        position: 'left'
      }
    ]
  },

  // ==================== NOMENCLATURES ====================
  nomenclatures_management: {
    id: 'nomenclatures_management',
    name: 'Gestion des Nomenclatures',
    steps: [
      {
        targetId: 'nomenclatures-intro',
        title: '📋 Nomenclatures',
        content: 'Gérez les codes d\'activités du bâtiment organisés par catégories.',
        position: 'bottom'
      },
      {
        targetId: 'categories-filter',
        title: '🏗️ Catégories',
        content: 'Filtrez par catégorie : Gros Œuvre, Second Œuvre, Travaux Publics, PIB.',
        position: 'bottom'
      },
      {
        targetId: 'nomenclature-card',
        title: '📦 Fiche Nomenclature',
        content: 'Chaque nomenclature affiche son code, sa catégorie et son statut (En ligne/Archivé).',
        position: 'bottom'
      },
      {
        targetId: 'simulateur-badge',
        title: '🧮 Badge Simulateur',
        content: 'Ce badge indique que l\'activité est liée à un simulateur pour le calcul des contributions.',
        position: 'left'
      },
      {
        targetId: 'edit-nomenclature',
        title: '✏️ Modifier',
        content: 'Modifiez le nom, la description, les exclusions et la liaison avec le simulateur.',
        position: 'left'
      }
    ]
  },

  // ==================== ADMIN BILLING ====================
  admin_billing: {
    id: 'admin_billing',
    name: 'Administration du modèle économique',
    steps: [
      {
        targetId: 'statistics-cards',
        title: '📊 Vue d\'Ensemble',
        content: 'Consultez les statistiques en temps réel : nombre de plans, packages, abonnements actifs.',
        position: 'bottom'
      },
      {
        targetId: 'plans-tab',
        title: '💼 Gestion des Plans',
        content: 'Créez, modifiez ou supprimez les plans d\'abonnement pour Membres et Conseillers.',
        position: 'bottom'
      },
      {
        targetId: 'create-plan-button',
        title: '➕ Créer un Plan',
        content: 'Cliquez ici pour créer un nouveau plan avec prix, crédits offerts et fonctionnalités personnalisées.',
        position: 'left'
      },
      {
        targetId: 'plan-card',
        title: '✏️ Modifier/Supprimer',
        content: 'Chaque plan peut être modifié ou supprimé. La suppression est protégée si des abonnements actifs existent.',
        position: 'top'
      },
      {
        targetId: 'packages-tab',
        title: '📦 Packages Crédits',
        content: 'Gérez les packages de crédits disponibles à l\'achat avec leurs tarifs dégressifs.',
        position: 'bottom'
      }
    ]
  }
};
